/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	routeNewsletter = 'route-newsletter',
}

/* -------------------------------------------------------------------------------------------------
 * Route loader
 * -----------------------------------------------------------------------------------------------*/

enum ROUTE_LOADER {
	current = 'routes/($lang).newsletter',
}

/* -------------------------------------------------------------------------------------------------
 * Search params
 * -----------------------------------------------------------------------------------------------*/

enum SEARCH_PARAMS {
	newsletterSubscribed = 'newsletter-subscribed',
	email = 'newsletterEmail',
}

/* -----------------------------------------------------------------------------------------------*/

export {
	I18NEXT as NEWSLETTER_I18NEXT,
	ROUTE_LOADER as NEWSLETTER_ROUTE_LOADER,
	SEARCH_PARAMS as NEWSLETTER_SEARCH_PARAMS,
}
